import React from "react";
import PendingTitlingWrapper from "./PendingTitlingWrapper";
import { Button, Typography } from "@mui/material";
import { Box } from "@mui/system";
import styles from "../../../../styles/pages/user/copyrwriterdashboard_dev/pending-titling-revised.module.scss";
import CalenderIcon from "../../../../ui/Icons/CalenderIcon";
import PendingTitlingRevisedTable from "../../../../components/AllTable/CopywritePageTable/PendingTitlingRevisedTable";

const PendingTitlingRevised = () => {
  return (
    <PendingTitlingWrapper>
      <Box className={styles.tableWrapper}>
        {/* <Box className={styles.TitlingRightDate}>
          <Box className={styles.TitlingRightDateTxt}>
            <Typography>
              Showing videos for <span>All Time</span>
            </Typography>
            <Typography className={styles.TitlingRightDateTxtDate}>
              (April 23, 2023 - Today)
            </Typography>
          </Box>
          <Box className={styles.TitlingRightDateImg}>
            <Button className={styles.calenderButton}>
              <CalenderIcon />
            </Button>
            <Button className={styles.allVideo_leftMargin}>
              {" "}
              All videos: <span>278</span>
            </Button>
          </Box>
        </Box> */}
        <Box className={styles.table}>
          <PendingTitlingRevisedTable />
        </Box>
      </Box>
    </PendingTitlingWrapper>
  );
};

export default PendingTitlingRevised;
